import React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { MessageInfo, MessageType } from '../../typings/messagesState';
import { ModerationMessage } from '../ModerationMessage/ModerationMessage';

import './Messages.css';

export interface MessagesProps {
    messages: MessageInfo[];

    confirmModerationMessage: (campaignId: string) => void;
    cancelModerationMessage: () => void;
}

const BLOCK = 'messages';

export class Messages extends React.PureComponent<MessagesProps> {
    render() {
        const { messages } = this.props;

        if (!messages || !messages.length) {
            return null;
        }

        return (
            <div className={Bem.cls(BLOCK)}>
                {messages.map((msg, ind) => (
                    <div key={ind}>{this.renderMessage(msg)}</div>
                ))}
            </div>
        );
    }

    private renderMessage(msg: MessageInfo) {
        switch (msg.type) {
            case MessageType.MODERATION:
                return (
                    <ModerationMessage
                        campaignId={msg.payload.campaignId}
                        confirm={this.props.confirmModerationMessage}
                        cancel={this.props.cancelModerationMessage}
                    />
                );

            default:
                return null;
        }
    }
}
